import { useQuery } from "@tanstack/react-query";
import { getProducts, getProduct, getCustomers, getCompanyDetails, getInvoiceDetails, getInvoices, getInvoiceSettings } from "./query-functions";
export const useFetchProducts = (config)=>useQuery({
        queryKey: [
            "products"
        ],
        queryFn: getProducts,
        ...config
    });
export const useFetchProduct = (productId, config)=>useQuery({
        queryKey: [
            "product",
            productId
        ],
        queryFn: getProduct,
        ...config
    });
export const useFetchCustomers = (config)=>useQuery({
        queryKey: [
            "customers"
        ],
        queryFn: getCustomers,
        ...config
    });
export const useFetchCompanyDetails = (config)=>useQuery({
        queryKey: [
            "company-details"
        ],
        queryFn: getCompanyDetails,
        ...config
    });
export const useFetchInvoiceSettings = (config)=>useQuery({
        queryKey: [
            "invoice-settings"
        ],
        queryFn: getInvoiceSettings,
        ...config
    });
export const useFetchInvoiceDetails = (invoiceId, config)=>useQuery({
        queryKey: [
            "invoices",
            invoiceId
        ],
        queryFn: getInvoiceDetails,
        ...config
    });
export const useFetchInvoices = (params, config)=>useQuery({
        queryKey: [
            "invoices",
            params
        ],
        queryFn: getInvoices,
        ...config
    });
